import { render, staticRenderFns } from "./ProjectArchives.vue?vue&type=template&id=55ea890e&"
import script from "./ProjectArchives.vue?vue&type=script&lang=js&"
export * from "./ProjectArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports